
export default {
  props: {
    reviews: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      slidesToShow: 1,
      firstIndex: 0,
      lastIndex: 0,
      disablePreviousBtn: true,
      disableNextBtn: false
    }
  },
  mounted() {
    const content = this.$refs['carousel-swiper']
    content.addEventListener('touchstart', (e) => {
      this.touchstartX = e.changedTouches[0].screenX
      this.touchstartY = e.changedTouches[0].screenY
    })
    content.addEventListener('touchend', (e) => {
      this.touchendX = e.changedTouches[0].screenX
      this.touchendY = e.changedTouches[0].screenY
      this.handleGesture()
    })
  },
  methods: {
    handleGesture() {
      if (
          this.touchendX < this.touchstartX &&
          Math.abs(this.touchendX - this.touchstartX) > 50 &&
          Math.abs(this.touchendY - this.touchstartY) < 50 &&
          this.touchstartY > 100
      ) {
        if (this.reviews[this.firstIndex + 1]) this.next()
      }

      if (
          this.touchendX > this.touchstartX &&
          Math.abs(this.touchendX - this.touchstartX) > 50 &&
          Math.abs(this.touchendY - this.touchstartY) < 50 &&
          this.touchstartY > 100
      ) {
        this.prev()
      }
    },
    next() {
      const itemsObj = this.$refs['slide-item']
      const items = Object.keys(itemsObj).map((key) => itemsObj[key])
      this.lastIndex = this.firstIndex - 1

      const index = this.firstIndex
      const itemsNew = items.slice(index, this.slidesToShow + index)
      if (itemsNew.length < 1) {
        this.setButtonsStatus(items.length)
        return
      }
      this.firstIndex = this.firstIndex + 1
      this.setButtonsStatus(items.length)
    },
    prev() {
      const itemsObj = this.$refs['slide-item']
      const items = Object.keys(itemsObj).map((key) => itemsObj[key])
      const index = this.lastIndex
      this.firstIndex = this.lastIndex + 1
      const itemsNew = items.slice(index, this.slidesToShow + index)
      if (itemsNew.length < 1) {
        this.setButtonsStatus(items.length)
        return
      }
      this.lastIndex = this.lastIndex - 1
      this.setButtonsStatus(items.length)
    },
    setButtonsStatus(itemLength) {
      this.resetButtons()
      let length = itemLength - 3
      if (this.firstIndex === 0) {
        this.disablePreviousBtn = true
      }
      if (this.lastIndex === length) {
        this.disableNextBtn = true
      }
    },
    resetButtons() {
      this.disableNextBtn = false
      this.disablePreviousBtn = false
    }
  }
}
